// src/components/admin/EditJewellery.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const EditJewellery = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        category: '',
        type: '',
        price: '',
        weight: '',
        description: '',
        image: null,
        purity: '',
        status: '',
        karigar: '',
        tags: '',
        visibility: false
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        const fetchItem = async () => {
            try {
                const response = await axios.get(`/api/jewellery/${id}`);
                const item = response.data;
                setFormData({
                    name: item.name || '',
                    category: item.category || '',
                    type: item.type || '',
                    price: item.price || '',
                    weight: item.weight || '',
                    description: item.description || '',
                    purity: item.purity || '',
                    status: item.status || 'Active',
                    visibility: item.visibility || false,
                    karigar: item.karigar || '',
                    tags: item.tags ? item.tags.join(', ') : '',
                    // image is handled as file upload, or we keep existing if not changed
                    image: item.image || null
                });
                setLoading(false);
            } catch (err) {
                console.error('Error fetching jewellery details:', err);
                setError('Failed to load item details.');
                setLoading(false);
            }
        };
        fetchItem();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : (files ? files[0] : value),
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = new FormData();
        for (const key in formData) {
            if (formData[key] !== null && formData[key] !== undefined) {
                // Append all fields to FormData. 
                // If image is a string (existing path), it sends as text. Backend "req.body.image" picks it up.
                // If image is a File (new upload), it sends as file. Backend "req.file" picks it up.
                form.append(key, formData[key]);
            }
        }

        try {
            const response = await axios.put(`/api/jewellery/${id}`, form, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setSuccess('Jewellery item updated successfully!');
            setError(null);
            setTimeout(() => navigate('/admin/jewellery-list'), 1500);
        } catch (error) {
            console.error('Error updating jewellery item:', error);
            setError(error.response?.data?.message || 'Error updating jewellery item');
            setSuccess(null);
        }
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div className="add-jewellery-container">
            <h2>Edit Jewellery Item</h2>
            {error && <div className="error" style={{ backgroundColor: 'red', color: 'white', padding: '10px' }}>{error}</div>}
            {success && <div className="success" style={{ backgroundColor: 'green', color: 'white', padding: '10px' }}>{success}</div>}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Name:</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Category:</label>
                    <input type="text" name="category" value={formData.category} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Type:</label>
                    <select name="type" value={formData.type} onChange={handleChange} required>
                        <option value="">Select Type</option>
                        <option value="gold">Gold</option>
                        <option value="silver">Silver</option>
                        <option value="custom">Custom</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Price:</label>
                    <input type="number" name="price" value={formData.price} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Weight (grams):</label>
                    <input type="number" name="weight" value={formData.weight} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Karigar (Source):</label>
                    <input type="text" name="karigar" value={formData.karigar} onChange={handleChange} placeholder="e.g. Ramesh Gold Works" />
                </div>
                <div className="form-group">
                    <label>Tags (comma separated):</label>
                    <input type="text" name="tags" value={formData.tags} onChange={handleChange} placeholder="e.g. Wedding, Daily Wear" />
                </div>
                <div className="form-group">
                    <label>Status:</label>
                    <select name="status" value={formData.status} onChange={handleChange}>
                        <option value="Draft">Draft</option>
                        <option value="Active">Active</option>
                        <option value="Available">Available</option>
                        <option value="Reserved">Reserved</option>
                        <option value="Sold">Sold</option>
                        <option value="Hidden">Hidden</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Purity:</label>
                    <input type="text" name="purity" value={formData.purity} onChange={handleChange} placeholder="e.g. 22K" />
                </div>
                <div className="form-group">
                    <label>Description:</label>
                    <textarea name="description" value={formData.description} onChange={handleChange} required></textarea>
                </div>
                <div className="form-group">
                    <label>Image (optional):</label>
                    {/* If string, show it's set? Or just input for new file. Logic simplifies to just input. */}
                    <input type="file" name="image" onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Visibility:</label>
                    <input type="checkbox" name="visibility" checked={formData.visibility} onChange={handleChange} /> Visible to Public
                </div>
                <button type="submit">Update Jewellery</button>
            </form>
        </div>
    );
};

export default EditJewellery;
